/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Breadcrumbs, Button, Dialog, DialogContent, Link, styled, Tab, Tabs, Typography, Tooltip, Menu, Divider } from "@mui/material";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { useSelector } from "react-redux";
import { apiRequest } from "../../../common/common";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { useEffect, useState } from "react";
import { LoadingPage } from "../../../common/LoadingPage";
import { Edit } from "@mui/icons-material";
import ProjectDetails from "./ProjectDetails.js";
import CreateProject from "./CreateProject.js";
import BuildingModule from "./Building/BuildingModule.js";
import LevelModule from "./Level/LevelModule.js";
import DepartmentModule from "./Department/DepartmentModule.js";
import RoomModule from "./Room/RoomModule.js";
import ItemsModule from "./Items/ItemsModule.js";
import HistoryModule from "./HistoryModule.js";
import ReviewItemModule from "./ReviewItem/ReviewItemModule.js";
import { CurrencyJSON } from "../../../common/const.js";
import BudgetModule from "./Budget/BudgetModule.js";
import Reports from "./ReportModule.js";
import Procurement from "./Procurement.js";

const DemoTabs = styled(Tabs)(({ theme }) => ({
    minWidth: 200,
    [theme.breakpoints.down('xs')]: {
        marginLeft: '0%',
    },
    [theme.breakpoints.down('md')]: {
        minWidth: '20px',
        fontSize: 10,
    },
}));

const DemoTab = styled(Tab)(({ theme }) => ({
    minWidth: 110,
    fontSize: 15,
    fontFamily: 'open sans',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    [theme.breakpoints.down('xs')]: {
        minWidth: 8,
        fontSize: 10,
    },
    '&:hover': {
        backgroundColor: '#f6f7ff',
        color: 'black',
    },
}));

const EditProject = ({
    selectedProject,
    setSelectedProject,
    getInitialData
}) => {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [dataLoading, setDataLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(localStorage.getItem('itemData') ? 'Items' : 'Details');
    const [building, setBuilding] = useState(null);
    const [level, setLevel] = useState(null);
    const [department, setDepartment] = useState(null);
    const [room, setRoom] = useState(null);
    const [item, setItem] = useState(localStorage.getItem('itemData') ? JSON.parse(localStorage.getItem('itemData')) : null);
    const [editOpen, setEditOpen] = useState(false);
    const [rows, setRows] = useState([
        { extension: '--', type: 'Image', resource: '--', size: '--', sortUrl: '' },
        { extension: '--', type: 'URL', resource: '--', size: '--', sortUrl: '' }
    ]);
    const [projectData, setProjectData] = useState({});
    const [budgetMenu, setBudgetMenu] = useState(false);
    const [budget, setBudget] = useState(null);
    const [totalTax, setTotalTax] = useState(0);
    const [tax, setTax] = useState(0);

    const calculateTax = () => {
        let tax = 0;
        let averageTax = 0
        const { additions = {}, deductions = {}, taxable_option } = projectData || {};
        const taxableOptions = taxable_option ? JSON.parse(taxable_option) : [];

        const totalCost = Number(budget?.total_cost) || 0;
        const taxRate = Number(additions?.tax?.actual?.value) || 0;

        if (budget?.total_tax > 0) {
            tax += budget?.total_tax;
            averageTax += budget?.total_tax;
        }

        const getValue = (budget, item, label) => {
            if (!item?.actual) return 0;

            const { scope, type, value } = item.actual;
            const val = scope ? Number(scope === 'project' ? value : budget[`total_${label.toLowerCase()}`]) : value;

            if (type === 'rate') {
                return (totalCost * val) / 100;
            }

            return val;
        };

        const calculateAddition = (budget, item, label) => {
            const baseValue = getValue(budget, item, label);
            tax += baseValue;

            if (taxableOptions.includes(label)) {
                tax += (baseValue * taxRate) / 100;
                averageTax += (baseValue * taxRate) / 100;
            }
        };

        calculateAddition(budget, additions?.contingency, 'Contingency');
        calculateAddition(budget, additions?.inflation, 'Inflation');
        calculateAddition(budget, additions?.installation, 'Installation');
        calculateAddition(budget, additions?.storage, 'Storage');
        calculateAddition(budget, additions?.fees, 'Fees');
        calculateAddition(budget, additions?.freight, 'Freight');

        const calculateDeduction = (budget, item, label) => {
            const value = getValue(budget, item, label);
            tax -= value;
        };

        calculateDeduction(budget, deductions?.discount, 'Discounts');
        calculateDeduction(budget, deductions?.reuse, 'Tradein');

        setTax(averageTax);
        setTotalTax(tax);
    };


    const getData = async () => {
        try {
            const response = await apiRequest('get', `/project/${selectedProject}`);
            if (response?.data) {
                const { data } = response?.data;
                setProjectData(data);
                const getFileData = (key) => {
                    const file = data?.[key]?.[0];
                    if (!file) return {};
                    return {
                        resource: file?.fileName || file?.sortUrl.split('/').pop().split('&')[0].split(/\.(?=[^\.]+$)/)[0],
                        size: file.size ? `${(file.size / 1024).toFixed(2)} KB` : '--',
                        extension: file?.fileName?.split('.')?.pop() || file?.sortUrl.split('/').pop().split('&')[0].split(/\.(?=[^\.]+$)/)[1] || '--',
                        sortUrl: file?.sortUrl
                    };
                };
                setRows((prevData) =>
                    prevData.map((row) => {
                        if (row.type === 'Image') {
                            return { ...row, ...getFileData('images') };
                        }
                        if (row.type === 'URL') {
                            const resourceValue = data?.["website_url"]?.length > 0 ? data?.["website_url"]?.toString() : '--';
                            return {
                                ...row,
                                resource: resourceValue !== '--' ? resourceValue : '--',
                                extension: resourceValue !== '--' ? 'URL' : '--',
                            };
                        }
                        return row;
                    })
                );
                setDataLoading(false);
            }
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getBudgetData = async () => {
        try {
            const response = await apiRequest('get', `/project/total-cost/${selectedProject}`);
            if (response.data) {
                const { data } = response.data;
                setBudget(data);
                setDataLoading(false);
            }
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if (selectedProject) {
            setDataLoading(true);
            getData();
        }
    }, [selectedProject]);

    useEffect(() => {
        if (budgetMenu) {
            setDataLoading(false);
            getBudgetData();
        }
    }, [budgetMenu]);

    useEffect(() => {
        if (budget && projectData) {
            calculateTax();
        }
    }, [budget, projectData]);


    return (
        <Box>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <Dialog
                open={editOpen}
                fullWidth
                maxWidth="xl"
            >
                <DialogContent>
                    <CreateProject
                        projectId={projectData?.project_id}
                        handleClose={() => {
                            setEditOpen(false);
                            getData();
                            getInitialData(1);
                        }}
                    />
                </DialogContent>
            </Dialog>
            <Breadcrumbs aria-label="breadcrumb">
                <Link
                    style={{ textDecoration: 'none', cursor: 'pointer' }}
                    color="inherit"
                    onClick={() => {
                        setSelectedProject(null);
                        localStorage.removeItem('projectData');
                    }}
                >
                    Projects
                </Link>
                <Link
                    style={{ textDecoration: 'none', cursor: 'pointer' }}
                    color="inherit"
                    onClick={() => {
                        setActiveTab('Details');
                        setBuilding(null);
                        setLevel(null);
                        setDepartment(null);
                        setRoom(null);
                        setItem(null);
                        localStorage.removeItem('itemData');
                    }}
                >
                    {projectData?.name}
                </Link>
                {building !== null && (
                    <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        color="inherit"
                        onClick={() => {
                            setActiveTab('Buildings');
                            setBuilding(null);
                            setLevel(null);
                            setDepartment(null);
                            setRoom(null);
                            setItem(null);
                            localStorage.removeItem('itemData');
                        }}
                    >
                        {building?.building_name}
                    </Link>
                )}
                {level !== null && (
                    <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        color="inherit"
                        onClick={() => {
                            setActiveTab('Levels');
                            setLevel(null);
                            setDepartment(null);
                            setRoom(null);
                            setItem(null);
                            localStorage.removeItem('itemData');
                        }}
                    >
                        {level?.level_name}
                    </Link>
                )}
                {department !== null && (
                    <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        color="inherit"
                        onClick={() => {
                            setActiveTab('Departments');
                            setDepartment(null);
                            setRoom(null);
                            setItem(null);
                            localStorage.removeItem('itemData');
                        }}
                    >
                        {department?.department_name}
                    </Link>
                )}
                {room !== null && (
                    <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        color="inherit"
                        onClick={() => {
                            setActiveTab('Rooms');
                            setRoom(null);
                            setItem(null);
                            localStorage.removeItem('itemData');
                        }}
                    >
                        {room?.room_name}
                    </Link>
                )}
                {item !== null && (
                    <Link
                        style={{ textDecoration: 'none', cursor: 'pointer' }}
                        color="inherit"
                        onClick={() => {
                            setActiveTab('Items');
                            setItem(null);
                            localStorage.removeItem('itemData');
                        }}
                    >
                        Items
                    </Link>
                )}
                {item !== null ? (
                    <Typography color="primary">{item?.product_data?.model ? item?.product_data?.model : item?.product?.model !== 'null' ? item?.product?.model !== null ? item?.product?.model : 'UnSpecified' : 'UnSpecified'}</Typography>
                ) : (
                    <Typography color="primary">{activeTab}</Typography>
                )}
            </Breadcrumbs>
            {(item === null && (activeTab !== 'Overview' && activeTab !== 'Reports')) && (
                <>
                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                            {projectData?.owner_ids?.includes(user?.user_id) ? (
                                <StarIcon
                                    color="primary"
                                    style={{ cursor: 'pointer' }}
                                    onClick={async () => {
                                        const ownerIds = projectData?.owner_ids;
                                        const index = ownerIds.findIndex((a) => a === user?.user_id);
                                        if (index > -1) {
                                            ownerIds.splice(index, 1);
                                        }
                                        setDataLoading(true);
                                        try {
                                            const response = await apiRequest('put', `/project/${projectData.project_id}`, {
                                                owner_ids: ownerIds,
                                                name: projectData?.name,
                                                organization_id: projectData?.organization_id,
                                                owner_id: projectData?.owner_id
                                            });
                                            if (response?.data) {
                                                getInitialData(1);
                                                setDataLoading(false);
                                            }
                                        } catch (error) {
                                            setDataLoading(false);
                                            showNotification(error?.response?.data.error || error.message, 'error');
                                        }
                                    }}
                                />
                            ) : (
                                <StarBorderIcon
                                    color="primary"
                                    style={{ cursor: 'pointer' }}
                                    onClick={async () => {
                                        const ownerIds = projectData?.owner_ids;
                                        ownerIds.push(user?.user_id);
                                        setDataLoading(true);
                                        try {
                                            const response = await apiRequest('put', `/project/${projectData.project_id}`, {
                                                owner_ids: ownerIds,
                                                name: projectData?.name,
                                                organization_id: projectData?.organization_id,
                                                owner_id: projectData?.owner_id
                                            });
                                            if (response?.data) {
                                                getInitialData(1);
                                                setDataLoading(false);
                                            }
                                        } catch (error) {
                                            setDataLoading(false);
                                            showNotification(error?.response?.data.error || error.message, 'error');
                                        }
                                    }}
                                />
                            )}
                            <Typography variant="h6">{projectData?.name}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Tooltip title="Project Budget">
                                <img
                                    src="/images/budget.png"
                                    alt="budget"
                                    style={{
                                        width: '35px',
                                        height: '35px',
                                        cursor: 'pointer'
                                    }}
                                    onClick={(e) => setBudgetMenu(e.currentTarget)}
                                />
                            </Tooltip>
                            <Menu
                                id="profile-menu"
                                open={Boolean(budgetMenu)}
                                anchorEl={budgetMenu}
                                onClose={() => setBudgetMenu(null)}
                                sx={{ marginTop: 1 }}
                                PaperProps={{
                                    sx: {
                                        backgroundColor: 'background.paper',
                                        borderRadius: '8px',
                                        boxShadow: 3,
                                        minWidth: '300px',
                                    },
                                }}
                            >
                                <div style={{ padding: '2px 0px 10px 20px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 16,
                                            textDecoration: 'none',
                                            fontWeight: 600
                                        }}
                                    >
                                        {`Project Budget (${projectData?.currency})`}
                                    </Typography>
                                </div>
                                <Divider />
                                <div style={{ padding: '7px 10px 7px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                            fontWeight: 600
                                        }}
                                    >
                                        Planned Subtotal:
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                        }}
                                    >
                                        {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${budget?.total_cost ? Intl.NumberFormat('en-IN').format(budget?.total_cost) : 0}`}
                                    </Typography>
                                </div>
                                <Divider />
                                <div style={{ padding: '7px 10px 7px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                            fontWeight: 600
                                        }}
                                    >
                                        Additions and Deductions:
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                        }}
                                    >
                                        {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(totalTax)}`}
                                    </Typography>
                                </div>
                                <Divider />
                                <div style={{ padding: '7px 10px 7px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                            fontWeight: 600
                                        }}
                                    >
                                        Total:
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                        }}
                                    >
                                        {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${budget?.total_cost ? Intl.NumberFormat('en-IN').format(Number(totalTax) + Number(budget?.total_cost)) : 0}`}
                                    </Typography>
                                </div>
                                <Divider />
                                <div style={{ padding: '7px 10px 7px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                            fontWeight: 600
                                        }}
                                    >
                                        Total Approved Budget:
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                        }}
                                    >
                                        {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(projectData?.total_approved_budget || 0)}`}
                                    </Typography>
                                </div>
                                <Divider />
                                <div style={{ padding: '7px 10px 7px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                            fontWeight: 600
                                        }}
                                    >
                                        Project Variance:
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                            color: projectData?.total_approved_budget - (Number(totalTax) + Number(budget?.total_cost)) >= 0 ? 'green' : 'red'
                                        }}
                                    >
                                        {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${budget?.total_cost ?
                                            Intl.NumberFormat('en-IN').format(projectData?.total_approved_budget - (Number(totalTax) + Number(budget?.total_cost))) : Intl.NumberFormat('en-IN').format(projectData?.total_approved_budget || 0)}`}
                                    </Typography>
                                </div>
                                <Divider />
                                <div style={{ textAlign: 'center', padding: '20px 0px 15px 0px' }}>
                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            textDecoration: 'none',
                                            fontWeight: 600,
                                            cursor: 'pointer'
                                        }}
                                        color="primary"
                                        onClick={() => {
                                            localStorage.removeItem('search');
                                            setActiveTab('Overview');
                                            setBudgetMenu(null);
                                        }}
                                    >
                                        VIEW BUDGET SUMMARY....
                                    </Typography>
                                </div>
                            </Menu>
                            {isUser?.code !== 'orgGuestUser' && (
                                <Button
                                    size="Medium"
                                    variant="contained"
                                    onClick={() => {
                                        setEditOpen(true);
                                    }}
                                    startIcon={<Edit style={{ fontSize: 20 }} />}
                                    style={{
                                        textTransform: 'capitalize'
                                    }}
                                >
                                    Edit Project
                                </Button>
                            )}
                        </Box>
                    </Box>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <DemoTabs
                            value={activeTab}
                            variant="scrollable"
                            scrollButtons="auto"
                            onChange={(event, newValue) => {
                                localStorage.removeItem('search');
                                setActiveTab(newValue)
                                setBuilding(null);
                                setLevel(null);
                                setDepartment(null);
                                setRoom(null);
                            }}
                        >
                            <DemoTab label="Details" value="Details" />
                            <DemoTab label="Buildings" value="Buildings" />
                            <DemoTab label="Levels" value="Levels" />
                            <DemoTab label="Departments" value="Departments" />
                            <DemoTab label="Rooms" value="Rooms" />
                            <DemoTab label="Items" value="Items" />
                            {isUser?.code !== 'orgGuestUser' && (
                                <DemoTab label="Audit" value="History" />
                            )}
                            {isUser?.code !== 'orgGuestUser' && (
                                <DemoTab label="Reports" value="Reports" />
                            )}
                            {(user?.organization?.Subscriptions[0]?.is_procurement_assign || ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code)) && (
                                <DemoTab label="Procurement" value="Procurement" />
                            )}
                        </DemoTabs>
                    </Box>
                </>
            )}
            {(activeTab === 'Details' && item === null) && (<ProjectDetails selectedProject={projectData} rows={rows} getData={getData} setRows={setRows} />)}
            {(activeTab === 'Buildings' && item === null) && (<BuildingModule projectId={selectedProject} projectData={projectData} setActiveTab={setActiveTab} setBuilding={setBuilding} />)}
            {(activeTab === 'Levels' && item === null) && (<LevelModule projectId={selectedProject} projectData={projectData} setActiveTab={setActiveTab} building={building} setLevel={setLevel} />)}
            {(activeTab === 'Departments' && item === null) && (<DepartmentModule projectId={selectedProject} projectData={projectData} setActiveTab={setActiveTab} level={level} setDepartment={setDepartment} />)}
            {(activeTab === 'Rooms' && item === null) && (<RoomModule projectId={selectedProject} projectData={projectData} setActiveTab={setActiveTab} department={department} setRoom={setRoom} />)}
            {(activeTab === 'Items' && item === null) && (<ItemsModule projectId={selectedProject} projectData={projectData} setActiveTab={setActiveTab} room={room} setItem={setItem} />)}
            {(activeTab === 'Items' && item !== null) && (<ReviewItemModule
                projectData={projectData}
                item={item}
                setActiveTab={setActiveTab}
                setBuilding={setBuilding}
                setLevel={setLevel}
                setDepartment={setDepartment}
                setRoom={setRoom}
                setItem={setItem}
            />)}
            {(activeTab === 'History' && item === null) && (<HistoryModule projectId={selectedProject} />)}
            {(activeTab === 'Reports' && item === null) && (<Reports projectId={selectedProject} organizationId={projectData?.organization_id} createdBy={projectData?.created_by} clientOrganization={projectData.client_organization} clientLogos={projectData?.client_logo} projectData={projectData} activeMainTab={activeTab} />)}
            {(activeTab === 'Procurement' && item === null) && (<Procurement projectId={selectedProject} projectData={projectData} />)}
            {activeTab === 'Overview' && (<BudgetModule projectId={selectedProject} projectData={projectData} getData={getData} budget={budget} totalTax={totalTax} tax={tax} />)}
        </Box>
    )
}

export default EditProject;